export default "__VITE_ASSET__09195514__"